import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return ({
		root: {
			fontWeight: "bold",
			textTransform: "none" as const,
		},
	} satisfies Record<string, CSSObject>);
};
